import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { ApiService } from '../../core/api.service';

@Component({
  selector: 'ch-password-reset',
  standalone: true,
  imports: [FormsModule, RouterLink],
  templateUrl: './password-reset.component.html'
})
export class PasswordResetComponent {
  email = '';
  loading = false;
  message = '';

  constructor(private readonly api: ApiService) {}

  async submit(): Promise<void> {
    this.loading = true;
    this.message = '';
    try {
      await this.api.requestPasswordReset(this.email);
    } finally {
      this.loading = false;
      this.message = 'If this email exists, reset instructions have been sent.';
    }
  }
}
